import { Cookies } from "react-cookie";
import baseRequest from "./baseRequest";

export async function checkAuth() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  if (token) {
    //验证是否过期
    try {
      const base = baseRequest();
      const response = await fetch("/op/login/validate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...base,
        }),
      });
      const data = await response.json();
      if (data.ret === -1) {
        return false;
      }
      return true;
    } catch (e) {
      console.warn(e);
    }
  }
  return false;
}

export function signIn(data) {
  const cookies = new Cookies();
  cookies.set("token", data.data.token, { maxAge: 315576000 });
  cookies.set("account", data.data.account, { maxAge: 315576000 });
  window.location.reload();
}

export async function signOut() {
  const cookies = new Cookies();
  try {
    const base = baseRequest();
    const account = cookies.get("account");
    const response = await fetch("/op/login/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mid: account.mid,
        ...base,
      }),
    });
    const data = await response.json();
    if (data.ret === -1) {
      alert(data.msg);
      cookies.remove("token");
      cookies.remove("account");
      window.location.reload();
      return;
    }
    cookies.remove("token");
    cookies.remove("account");
    window.location.reload();
  } catch (error) {
    console.error(error);
  }
}
